import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
import {
    ProcessMobileExpressOrdersRequest,
    ProcessMobileExpressOrdersResponse,
} from '../../../types/models/payment/ProcessMobileExpressOrders.types';

const AddOrUpdateInstallmentManagement = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.AddOrUpdateInstallments,
        method: RequestType.POST,
        data,
    });

const DeleteInstallmentManagement = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.DeleteInstallments}`,
        method: RequestType.POST,
        data,
    });
const UpdateCustomerPaymentMethodAvailabilityStatus = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.UpdateCustomerPaymentMethodAvailabilityStatus}`,
        method: RequestType.POST,
        data,
    });
const RemoveCustomerPaymentMethodBlock = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.RemoveCustomerPaymentMethodBlock}`,
        method: RequestType.POST,
        data,
    });
const GetCustomerPaymentMethodAvailabilityStatusHistory = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.GetCustomerPaymentMethodAvailabilityStatusHistory}`,
        method: RequestType.POST,
        data,
    });
const GetCustomerPaymentRequestList = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.GetCustomerPaymentRequestList}`,
        method: RequestType.POST,
        data,
    });
const GetCardListByCustomerId = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.GetCardListByCustomerId}`,
        method: RequestType.POST,
        data,
    });
const GetPaymentsWithOrderIdList = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetPaymentsWithOrderIdList,
        method: RequestType.POST,
        data,
    });
const GetBankAccountListByCustomer = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.GetBankAccountListByCustomer}`,
        method: RequestType.POST,
        data,
    });
const InsertCustomerBankAccount = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.InsertCustomerBankAccount}`,
        method: RequestType.POST,
        data,
    });
const UpdateCustomerBankAccount = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateCustomerBankAccount,
        method: RequestType.POST,
        data,
    });
const CheckDigitalCardPayment = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CheckDigitalCardPayment,
        method: RequestType.POST,
        data,
    });
const SendPaymentSms = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SendPaymentSms,
        method: RequestType.POST,
        data,
    });
const SendEmailForDigitalCard = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SendEmailForDigitalCard,
        method: RequestType.POST,
        data,
    });
const DeleteCustomerBankAccount = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DeleteCustomerBankAccount,
        method: RequestType.DELETE,
        data,
    });
const GetBankAccountByCustomerBankAccountId = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetBankAccountByCustomerBankAccountId,
        method: RequestType.POST,
        data,
    });

const GetPaymentMethodList = (data?: any): Promise<any> =>
    request({
        url: ApiURL.Command.PaymentMethodList,
        method: RequestType.POST,
        data,
    });

const ProcessMobileExpressOrders = (
    data: ProcessMobileExpressOrdersRequest
): Promise<ProcessMobileExpressOrdersResponse> =>
    request({
        url: ApiURL.Command.ProcessMobileExpressOrders,
        method: RequestType.POST,
        data,
    });

const PaymentCommand = {
    AddOrUpdateInstallmentManagement,
    DeleteInstallmentManagement,
    UpdateCustomerPaymentMethodAvailabilityStatus,
    RemoveCustomerPaymentMethodBlock,
    GetCustomerPaymentMethodAvailabilityStatusHistory,
    GetCustomerPaymentRequestList,
    GetCardListByCustomerId,
    GetPaymentsWithOrderIdList,
    CheckDigitalCardPayment,
    UpdateCustomerBankAccount,
    GetBankAccountListByCustomer,
    InsertCustomerBankAccount,
    SendPaymentSms,
    SendEmailForDigitalCard,
    DeleteCustomerBankAccount,
    GetBankAccountByCustomerBankAccountId,
    GetPaymentMethodList,
    ProcessMobileExpressOrders,
};

export default PaymentCommand;
